import { Component, createRef } from "react";
import { connect } from "react-redux";
// import {change_header} from '../../../redux/actions/HeroBarAction'
import {set_datapage,getMapStateDefault} from '@ora/recursos/src/redux/actions/DataPageAction'
import { Templates } from "@ora/recursos";

import { Button, 
  Card, 

  Section
   } from 'react-bulma-components';
import { baseUrl, getValuesQueryArray, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";
import $ from 'jquery'
import dt from 'datatables.net'
import { tagActivo, buttonsAcciones } from "helpers/Datatables";
import Swal from "sweetalert2";
import { specifications } from "@ora/recursos/src/helpers/DublinCore";
$.DataTable = dt



class Exportaciones extends Component {
    _isMounted = false;
    requestInit = null;
    refFilterRecursos = null
    state = {
        listRecursos: [],
        import_vars: [],
        isloadsearch:true,
    }
    filter = {
        buscar: '',
        type: -1,
        dublin: -1
    }
    table = null
    datatable = null

    // eslint-disable-next-line no-useless-constructor
    constructor (props) {
        super(props)
        this.refFilterRecursos = createRef()
    }
    componentDidMount () {
        
        this._isMounted = true;
        this.requestInit = axios.CancelToken.source()
        this.props.set_datapage({ titulo: 'Gestión de exportaciones',
        isbackend:true,
        breadcrumb:[
            {name:"Intranet",url:"#"},
            {name:"Exportaciones",url:"#"},
            {name:"Gestión de exportaciones",url:"#",active:true},
        ]});
        this.init()
    }
    onClick_btnNuevo = () => {
        this.props.history.push(localUrl("/config/exportaciones/create"))
        
    }
    onClick_btnImportar = () => {
        this.props.history.push(localUrl("/recoleccion/importar/archivos" + (this.state.import_vars.length > 0 
            ? `?imports=${this.state.import_vars.join(',')}` 
            : '')))
        
    }
    // componentWillMount () {
        
      
    // }
    componentWillUnmount() {
        this._isMounted = false;
        if (this.requestInit) this.requestInit.cancel()


    }
    init = () => {
        let filterResource = getValuesQueryArray(this.props.location, 'resource')

        const OnCall = () => {

            this.setState({                   
                isloadsearch: true
            })
            
        }
        const OnFinish = () => {
    
            this.setState({                   
                isloadsearch: false
            })
            
        }
       
        axios.get(baseUrl('cites/exportaciones'), { cancelToken: this.requestInit.token }).then(res => {
            if (res.data.success) {
                this._isMounted && this.setState({
                    listRecursos: res.data.data.recursos.filter(item => {
                        return filterResource.length > 0 ? filterResource.includes(item.id) : true
                    }),
                    import_vars: res.data.data.import_vars
                })
                if (filterResource.length > 0) {
                    this.refFilterRecursos.current.value = filterResource[0]
                    this.filter.recurso = filterResource[0]
                }
            }
        }).then(dataT => {

            this.configDT =  {
                data: [],
                dom: "<'columns'<'column is-full'<'table-container't>>><'columns'<'column'l><'column'p>>",
                // dom: "<'b-table'<'table-wrapper'<'table-container't>><'top level'<'level-left'l><'level-right'p>>",
                processing: true,
                ajax: {
                  url: baseUrl("cites/exportaciones/datatable"),
                  data: (d) => {
                    d.filter = this.filter
                    return d
                  },
                  beforeSend: function () {
                    OnCall(); // show wating animation
                  },
                  error: function (xhr, error, thrown) {
                    OnFinish()
                    //alert(xhr.status);
                    //alert(thrown);
                    Swal.fire({
                        title: thrown,
                        html: `
                         <p> Se encontró un error en el servidor, intente más tarde.</p>
                         <p>Mensaje: ${xhr.status} - ${error}</p>
                        `,
                        icon: 'error'
                    }).then(sr => {
                        
                      })
                    
                  }
                },
                serverSide: true,
                order: [[0, "desc"]],
                createdRow: (r, d, i) => {
                //   new Vue().$mount(r.querySelector(".cell-options"));
                },
                columns: [
                  { data: "exp_int_id", render: (d, t, r)=>{
                    return r.index
                  }},
                  { data: "exp_txt_taxon" },
                  { data: "exp_int_year" },
                  { data: "exp_txt_appendix" },
                  { data: "exp_txt_term" },
                  { data: "exp_int_quantity" },
                  { data: "rec_txt_name" },
                //   { data: "var_txt_name" },
                  { data: "exp_sts_registro", render: (d, t, r) => {
                    return tagActivo(d)
                  } },
                  { data: "exp_int_id", render: buttonsAcciones({
                    baseurl: localUrl('/config/exportaciones/'),
                    translateUrl: localUrl('/translate/exportaciones/')
                  }), orderable: false }
                ],
                drawCallback: (dcall) => {
                    this.setState({                   
                        total:dcall._iRecordsDisplay,
                        isloadsearch: false
                    })
                    $('#tblExportacionesGG_paginate a.previous').addClass("pagination-link pagination-previous");
                    $('#tblExportacionesGG_paginate a.next').addClass("pagination-link pagination-next");
                    $('#tblExportacionesGG_paginate a.next').addClass("pagination-link pagination-next");
                    $('#tblExportacionesGG_paginate span a.paginate_button.current').addClass("pagination-link is-current");
                    $('#tblExportacionesGG_paginate span a.paginate_button').addClass("pagination-link");
             
                  }
            }
            this.table = $('#tblExportacionesGG')
            
            this.datatable = this.table.DataTable(this.configDT).on('click', '.btn-acciones', this.OnClick_acciones)
        })

        


        
    }
    COptionDublin = () => {
        return specifications.map((item, index) => {
            return <option key={ index } value={ item.label }>{ item.label }</option>
        })
    }
    OnClick_acciones = (evt) => {
    //   console.log(this.props)
      evt.preventDefault()
      let {accion, id} = evt.currentTarget.dataset

      switch (accion) {
        case 'translate':
          this.props.history.push(localUrl('/translate/exportaciones/' + id))
          break;
        case 'ver':
          this.props.history.push(localUrl('/config/exportaciones/' + id))
          break;
        case 'editar':
          this.props.history.push(localUrl('/config/exportaciones/' + id + '/edit'))
          break;
        case 'estado':
          axios.put(baseUrl('cites/exportaciones/' + id + '?m=estado')).then(res => {
              if (res.data.success) {
                  this.datatable.draw(false)
              }
            Swal.fire(
                'Exportaciones',
                res.data.message,
                'success'
              ).then(sr => {
                
              })
          })
          break;
        case 'eliminar':
          axios.delete(baseUrl('cites/exportaciones/' + id)).then(res => {
              if (res.data.success) {
                  this.datatable.draw(false)
              }
            Swal.fire(
                'Exportaciones',
                res.data.message,
                'error'
              ).then(sr => {
                
              })
          })
          break;
      
        default:
          break;
      }
    }
    COptionRecursos = () => {
        return this.state.listRecursos.map((item, index) => <option key={index} value={item.id}>{item.name}</option>)
    }
    intervalFilter = null
    onChange = (evt) => {
        
        // if (['filterRecursos', 'filterType'].includes(evt.target.name)) {
        //     if (this.datatable) {
        //         this.filter.buscar = evt.target.elements.search.value
        //         this.filter.type = evt.target.elements.filterRecursos.value
        //         this.filter.dublin = evt.target.elements.filterType.value
        //         this.intervalFilter = setTimeout(() => {
        //             this.datatable.draw()
        //         }, 200)

        //     }
        // }

    }

    onSubmit_filter = (evt) => {
        evt.preventDefault()
        this.filter.buscar = evt.target.elements.search.value
        this.filter.recurso = evt.target.elements.filterRecursos.value
        // this.filter.dublin = evt.target.elements.filterType.value
        this.datatable.draw()
        

    }
    render() {
        return (
            <Templates.Default.BasePageRoute2 
      localUrl={ localUrl }
      dataPage={ this.props.DataPage }
      >
          <div className="is-main-section">
          <Card>
              {/* <Card.Header> */}
                 {/* <Card.Header.Title>
                     <span className="icon"><i className="mdi mdi-finance"></i></span>Importar
                 </Card.Header.Title> */}
                
              {/* </Card.Header> */}
              <Card.Content>
                {/* <Link to={localUrl('/config/recursos/1')}>ssss</Link> */}
                <div className="columns">
                    <div className="column level">
                        <div className="buttons level-right">

                                <Button type="button" onClick={ this.onClick_btnNuevo } className="is-info">Nueva registro</Button>
                                <Button type="button" onClick={ this.onClick_btnImportar } className="is-info">Importar desde archivo</Button>
                        </div>
                    </div>
                    
                </div>
                <form action="" onSubmit={ this.onSubmit_filter }>
                <div className="field is-horizontal">
                    <div className="field-body">
                        <div className="column is-3">
                            <div className="field">
                                <div className="control has-icons-left has-icons-right">
                                    <input type="text"
                                        autoComplete="on" placeholder="Taxon" name="search" className="input form-control" /><span className="icon is-left"><i
                                            className="fas fa-search"></i></span></div>
                              
                            </div>
                        </div>
                        <div className="column is-3">
                        <div className="field">
                            <div className="control">
                                <span className="select is-empty">
                                    <select ref={ this.refFilterRecursos } name="filterRecursos" onChange={ this.onChange } required="required">
                                        <option  value="-1"> - Recursos -
                                        </option>
                                        {this.COptionRecursos()}
                                        
                                    </select></span></div>
                        </div>
                        </div>
                        {/* <div className="column is-3">
                        <div className="field">
                            <div className="control">
                                <span className="select is-empty">
                                    <select name="filterType" onChange={ this.onChange } required="required">
                                        <option  value="-1"> - Tipo -
                                        </option>
                                        {this.COptionDublin()}
                                        
                                    </select></span></div>
                        </div>
                        </div> */}
                        <div className="column">
                            <Button className={"is-success "+(this.state.isloadsearch?"is-loading":"")}>Buscar</Button>
                        </div>
                       
                    </div>
                </div>
                </form>
                <hr/>
                <div className="columns">
                        <div className="column level">                          
                                <div className="level-right">
                                    <div className="level-item">
                                        {this.state.total} registros                                      
                                    </div>
                                </div>
                        </div>
                        
                    </div>
                <div className="b-table has-pagination">
                    <div className="table-wrapper">
                        <div>
                            <table id="tblExportacionesGG"
                                className="table is-fullwidth is-bordered is-hoverable is-fullwidth">
                                <thead>
                                    <tr>
                                        <th className="is-sortable">#</th>
                                        <th>Taxon</th>
                                        <th>Año</th>
                                        <th>Appendix</th>
                                        <th>Term</th>
                                        <th>Quantity</th>
                                        <th>Recurso</th>
                                        <th>Estado</th>
                                        <th>Opciones</th>

                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
         
              </Card.Content>
          </Card>
      </div>
      </Templates.Default.BasePageRoute2>
        )
    }
}

export default connect(getMapStateDefault(), {set_datapage})(Exportaciones)